import { render } from "./vehicle-image.vue?vue&type=template&id=042315d0"
import script from "./vehicle-image.vue?vue&type=script&lang=js"
export * from "./vehicle-image.vue?vue&type=script&lang=js"

import "./vehicle-image.vue?vue&type=style&index=0&id=042315d0&lang=css"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__